import { filtersHelper } from "@/utils";
import { authPermissionModel } from "./authPermission.model";

export const authLoginModel = (data) => {
  const permissions = data.user?.permissions ?? data.user?.permission ?? {};
  return {
    user: data.user
      ? {
          id: data.user.id,
          uuid: data.user.uuid,
          firstName: data.user.first_name,
          lastName: data.user.last_name,
          email: data.user.email,
          emailVerifiedAt: filtersHelper.getDateFormat(
            data.user.email_verified_at,
          ),
          phoneCode: data.user.phone_code,
          phoneIso: data.user.phone_iso,
          phone: data.user.phone,
          phoneVerifiedAt: filtersHelper.getDateFormat(
            data.user.phone_verified_at,
          ),
          image: data.user.image,
          appAccess: data.user.app_access,
          portalAccess: data.user.portal_access,
          portalLoginAttempt: data.user.portal_login_attempt,
          isOrientation: data.user.is_orientation,
          isSuperadmin: data.user.is_superadmin,
          isActive: data.user.is_active,
          createdAt: filtersHelper.getDateFormat(data.user.created_at),
          createdBy: data.user.created_by,
          updatedAt: filtersHelper.getDateFormat(data.user.updated_at),
          updatedBy: data.user.updated_by,
          deletedAt: filtersHelper.getDateFormat(data.user.deleted_at),
          deletedBy: data.user.deleted_by,
          permissions,
          permission: authPermissionModel(permissions),
          primaryCompany: data.user.primary_company
            ? {
                // todo
              }
            : null,
        }
      : null,
    token: data.token
      ? {
          tokenType: data.token.token_type,
          accessToken: data.token.access_token,
          expiresIn: data.token.expires_in,
          // expiresAt: filtersHelper.getDateFormat(data.token.expires_at),
          expiresAt: data.token.expires_at,
          refreshExpiresIn: data.token.refresh_expires_in,
          // refreshExpiresAt: filtersHelper.getDateFormat(data.token.refresh_expires_at),
          refreshExpiresAt: data.token.refresh_expires_at,
        }
      : null,
  };
};
